/** Map Firebase Auth error codes to short user-facing messages. */

const MESSAGES = {
  'auth/invalid-email': 'Please enter a valid email address.',
  'auth/user-disabled': 'This account has been disabled.',
  'auth/user-not-found': 'No account found for that email.',
  'auth/wrong-password': 'Incorrect password.',
  'auth/invalid-credential': 'Sign-in failed. Check your credentials and try again.',
  'auth/email-already-in-use': 'An account already exists with this email.',
  'auth/weak-password': 'Password should be at least 6 characters.',
  'auth/too-many-requests': 'Too many attempts. Please wait and try again.',
  'auth/popup-closed-by-user': 'Sign-in popup was closed before completing.',
  'auth/cancelled-popup-request': 'Another sign-in popup is already open.',
  'auth/account-exists-with-different-credential': 'An account already exists with the same email but different sign-in method.',
  'auth/invalid-verification-code': 'Invalid verification code.',
  'auth/invalid-verification-id': 'Verification session expired. Request a new code.',
  'auth/missing-phone-number': 'Please enter a phone number.',
  'auth/quota-exceeded': 'SMS quota exceeded. Try again later.',
  'auth/captcha-check-failed': 'reCAPTCHA check failed. Refresh the page and try again.',
  'auth/network-request-failed': 'Network error. Check your connection and try again.',
};

export function formatFirebaseAuthError(err) {
  if (!err) return 'Something went wrong. Please try again.';
  const code = err.code;
  if (code && MESSAGES[code]) return MESSAGES[code];
  if (typeof err.message === 'string' && err.message.length < 200) return err.message;
  return 'Something went wrong. Please try again.';
}
